/**
 * Constants used across the application
 */

// Local storage keys
export const LOCAL_STORAGE_KEYS = {
  SELECTED_PROJECT_ID: 'selectedProjectId',
  ACCESS_TOKEN: 'accessToken',
  REFRESH_TOKEN: 'refreshToken',
};
